export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9532.e4b13d1a.jpg";